const BASE_URL = process.env.REACT_APP_BACKEND_URL;

export default BASE_URL;
